var map = {
	"./boots/placeholder.jpg": "d7c4",
	"./gloves/placeholder.jpg": "6523",
	"./helmets/placeholder.jpg": "e30f",
	"./jackets/placeholder.jpg": "b3c2",
	"./pants/placeholder.jpg": "1838"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "379b";